import type { VideoItem } from '@/mocks/videos';

interface VideoPlayerProps {
  video: VideoItem;
}

export default function VideoPlayer({ video }: VideoPlayerProps) {
  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-background-900">
      <img
        src={video.coverImage}
        alt={video.title}
        title={`${video.title} - 51影视免费在线观看`}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
        <button
          type="button"
          className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-primary-500 hover:bg-primary-600 text-white transition-all duration-200 hover:scale-110 cursor-pointer"
          aria-label="播放视频"
        >
          <i className="ri-play-fill text-3xl md:text-4xl ml-1"></i>
        </button>
      </div>
      <div className="absolute bottom-3 right-3">
        <span className="px-3 py-1 bg-black/60 text-white text-xs rounded-md">{video.duration}</span>
      </div>
    </div>
  );
}